import React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const AnnounceOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <G clipPath="url(#a)" fill={color}>
        <Path d="M15.833 10.292c0-.725-.333-1.342-.833-1.675V4.883c0-.575-.417-1.016-.883-1.016a.8.8 0 0 0-.275.05l-7 2.633H3.325c-.917 0-1.658.742-1.658 1.658v3.584c0 .916.741 1.658 1.658 1.658h.525v.125l.658 2.517a.607.607 0 0 0 .742.433l.458-.117a.607.607 0 0 0 .434-.741l-.575-2.217h1.266l7 2.633a.8.8 0 0 0 .275.05c.475 0 .884-.433.884-1.016v-3.159c.5-.333.833-.958.833-1.675l.008.009ZM6.708 12.2H3.325a.409.409 0 0 1-.408-.408V8.208c0-.225.183-.408.408-.408H6.7v4.4h.008Zm7.042 2.517-5.683-2.142v-5.15l5.683-2.142v9.434ZM16.425 8.433a.51.51 0 0 1-.408-.208.506.506 0 0 1 .116-.7l1.042-.742a.506.506 0 0 1 .7.117.506.506 0 0 1-.117.7l-1.041.742a.484.484 0 0 1-.292.091ZM17.408 14.025a.521.521 0 0 1-.35-.142L16.133 13a.5.5 0 1 1 .692-.725l.925.883a.5.5 0 0 1 .017.709c-.1.1-.234.158-.359.158ZM18.108 10.775h-.016l-1.275-.042a.502.502 0 0 1-.484-.516c.009-.275.234-.509.517-.484l1.275.042a.502.502 0 0 1 .483.517.504.504 0 0 1-.5.483Z" />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h20v20H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default AnnounceOutlined
